import script from "./sub-device-command-record-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./sub-device-command-record-drawer.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__